// src/containers/Receptions/ReceptionList/components/OrderFormPopin.tsx
import React from "react";
import { useCommonStyles } from "$containers/CommonStyles/CommonStyles";
import { Popin } from "$components";
import OrderForm from "../../../Orders/forms/OrderForm";
import { IOrderFormPopinProps } from "../types";

const OrderFormPopin: React.FC<IOrderFormPopinProps> = ({
  order,
  orderNewValue,
  onSubmit,
  onCancelOrder,
  onReset,
  showOrderModal,
  setShowOrderModal,
  setOrderNewValue,
}) => {
  const commonClasses = useCommonStyles();

  const handleCancelOrder = () => onCancelOrder();
  const handleReset = () => onReset();

  return (
    <Popin
      customCloseAction={() => {
        setOrderNewValue(undefined);
      }}
      className={commonClasses.ProjectsPage_Popin}
      openPopin={showOrderModal}
      toggleDrawer={setShowOrderModal}
      minWidth="70%"
    >
      <OrderForm
        order={order}
        orderNewValue={orderNewValue}
        onSubmit={onSubmit}
        onCancelOrder={handleCancelOrder}
        onReset={handleReset}
      />
    </Popin>
  );
};

export default OrderFormPopin;
